module.exports = __webpack_public_path__ + "img/kit.09806ae4.png";